'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Activity {
  id: string;
  action: string;
  entity: string;
  user: string;
  time: string;
  icon: string;
}

const activities: Activity[] = [
  { id: 'act-001', action: 'Simulation run completed', entity: 'Financial Close Digital Twin', user: 'Marcus Osei', time: '12 min ago', icon: 'PlayCircleIcon' },
  { id: 'act-002', action: 'Root cause analysis triggered', entity: 'Customer Order BVO', user: 'Priya Nair', time: '34 min ago', icon: 'MagnifyingGlassIcon' },
  { id: 'act-003', action: 'Conformance threshold updated', entity: 'Cash Application BVO', user: 'Anika Kowalski', time: '1h ago', icon: 'AdjustmentsHorizontalIcon' },
  { id: 'act-004', action: 'New variant detected', entity: 'Supplier Invoice Process', user: 'System', time: '2h ago', icon: 'BoltIcon' },
  { id: 'act-005', action: 'BVO health report exported', entity: 'Working Capital BVO', user: 'James Whitfield', time: '3h ago', icon: 'ArrowDownTrayIcon' },
];

export default function ActivityFeed() {
  return (
    <div className="bg-card rounded-xl card-glow overflow-hidden">
      <div className="flex items-center justify-between px-5 py-4 border-b border-border">
        <h2 className="text-sm font-semibold text-foreground">Recent Activity</h2>
        <button className="text-xs text-muted-foreground hover:text-foreground transition-colors">View log</button>
      </div>
      <div className="divide-y divide-border">
        {activities.map((act) => (
          <div key={act.id} className="px-5 py-3 hover:bg-muted/20 transition-colors">
            <div className="flex items-start gap-3">
              <div className="p-1.5 rounded-lg bg-muted shrink-0 mt-0.5">
                <Icon name={act.icon as Parameters<typeof Icon>[0]['name']} size={12} className="text-muted-foreground" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-medium text-foreground">{act.action}</p>
                <p className="text-2xs text-primary truncate">{act.entity}</p>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-2xs text-muted-foreground">{act.user}</span>
                  <span className="text-2xs text-muted-foreground">·</span>
                  <span className="text-2xs text-muted-foreground">{act.time}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}